import { render, staticRenderFns } from "./dataList.vue?vue&type=template&id=42a049b7&scoped=true&"
import script from "./dataList.vue?vue&type=script&lang=js&"
export * from "./dataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a049b7",
  null
  
)

export default component.exports